<div class="app-top">
	<dev-bar></dev-bar>
	<router-outlet></router-outlet>
</div>

<div class="spinner-wrapper" [hidden]="!Sys.App.isSpinnerVisible">
	<div class="spinner-grid">
		<div class="spinner-content">
			<mat-spinner></mat-spinner>
			<div class="spinner-text">{{ Sys.App.spinnerText }}</div>
		</div>
	</div>
</div>
